import { css } from "@emotion/react";

export const swiper = props => css`
  padding-bottom: 10px;
  display: block !important;
  @media (min-width: ${props.theme.screenSizes.mdMax}) {
    padding-bottom: 52px;
  }
`;

export const cardStyles = props => css`
  .MuiCardContent-root {
    padding: 24px !important;

    @media (min-width: ${props.theme.screenSizes.mdMax}) {
      padding: 52px !important;
    }
  }

  .MuiButtonBase-root {
    height: 48px !important;
    width: 100%;

    @media (min-width: ${props.theme.screenSizes.mdMax}) {
      width: max-content;
    }
  }
`;

export const addStyles = {
  swiper,
  cardStyles,
};
